// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1-uJA","label":"CategoryService_label__2Zlgn","location":"CategoryService_location__OyiBR"};